import { defineMessages } from 'react-intl';

export default defineMessages({
	add: {
		id: 'pages.collections.add',
		defaultMessage: 'New Collection',
	},
	saveSearch: {
		id: 'pages.collections.saveSearch',
		defaultMessage: 'Save this search',
	},
	emptyDefault: {
		id: 'pages.collections.emptyDefault',
		defaultMessage: 'No collections found',
	},
	emptyFiltered: {
		id: 'pages.collections.emptyFiltered',
		defaultMessage: 'No collections match your search or filters.',
	},
	emptyGuideStep1: {
		id: 'pages.collections.emptyGuideStep1',
		defaultMessage:
			'Collections let you organise assets into groups. Private collections are visible only to you; group collections are shared with your team.',
	},
	emptyGuideStep2: {
		id: 'pages.collections.emptyGuideStep2',
		defaultMessage:
			'To create a collection, select assets on the {assetsPage} and use the {withSelected} dropdown to add them to a new collection or an existing collection.',
	},
	emptyGuideImageAlt: {
		id: 'pages.collections.emptyGuideImageAlt',
		defaultMessage:
			'Assets page showing several assets selected and the With Selected menu open with Create new Collection highlighted.',
	},
});
